module.exports = __webpack_public_path__ + "img/icon-MA-HelpYou.5c4fd2bb.png";